export enum ComplianceType {
  INSIGHTS = 'insights',
  HAVS = 'havs',
  VEHICLE_CHECK = 'vehicle-check',
  VEHICLE_CHECK_USER = 'vehicle-check-user',
}
